import React from 'react';
import { createRoot } from 'react-dom/client';
import './style/fonts.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Auth0Provider } from './react-auth0-spa';

import './i18n';
import history from './utils/history';

import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.scss';

const { REACT_APP_AUTH0_DOMAIN, REACT_APP_AUTH0_CLIENT_ID, REACT_APP_AUTH0_AUDIENCE } = process.env;

const onRedirectCallback = appState => {
  history.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
};

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Auth0Provider
    domain={REACT_APP_AUTH0_DOMAIN}
    client_id={REACT_APP_AUTH0_CLIENT_ID}
    audience={REACT_APP_AUTH0_AUDIENCE}
    redirect_uri={window.location.origin}
    onRedirectCallback={onRedirectCallback}
  >
    <App />
  </Auth0Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
serviceWorker.unregister();
